import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import StayConnected from './stayConnected';
import Logo from './../assets/img/NGF-logo.svg';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setIsMenuOpen(false)
        setOpen(true);

    }

    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [hash]);

    const handleClose = () => setOpen(false);

    const [mobileNav, setMobileNav] = useState(false);

    const closeMobileNav = () => {
        setMobileNav(false)
    }
    const openMobileNav = () => {
        setMobileNav(true)
    }

    return (
        <>

            <header>
                <div className="header-inner">
                    <Link className="logo" to="/">
                        <img src={Logo}
                            alt="Figgers Law Logo"
                            style={{ width: '110px' }} />
                        <div id="logoFallback" style={{ display: 'none', alignItems: 'center', gap: '12px' }}>
                            <div className="logo-icon">NGF</div>
                            <div className="logo-text">
                                <span className="logo-name">Figgers Law</span>
                                <span className="logo-sub">Natlie G. Figgers, Esq.</span>
                            </div>
                        </div>
                    </Link>

                    <nav className="desktop">
                        <Link to={'/about'}>About Us</Link>
                        <div className="nav-dropdown">
                            <span className="nav-dropdown-trigger">Practice Areas ▾</span>
                            <div className="nav-dropdown-menu">
                                <Link to={'/personal-injury'}>Personal Injury</Link>

                                <Link to={'/business-law'}>Business Law & Commercial Litigation</Link>

                            </div>
                        </div>
                        <Link to='/#highlights'>Case Highlights</Link>
                        <Link to={'/blog'}>Blog</Link>
                        <Link to={'/contact-us'}>Contact Us</Link>

                    </nav>

                    <div className="header-actions">
                        <a href="tel:+8556435291" className="header-phone">
                            <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24">
                                <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
                            </svg>
                            (855) 643-5291
                        </a>
                        <Link to={'/contact-us'} className="btn-gold">Free Consultation</Link>
                        <button className="mobile-menu-btn" onClick={openMobileNav} aria-label="Menu">
                            <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <path d="M4 5h16M4 12h16M4 19h16" />
                            </svg>
                        </button>
                    </div>
                </div>
            </header>

            {mobileNav ?
                <div className="mobile-nav open">
                    <span className="mobile-nav-close" onClick={closeMobileNav}>&#x2715;</span>
                    <Link to={'/'}>Home</Link>
                    <Link to={'/about'}>About Us</Link>
                    <Link to={'/blog'}>Blog</Link>
                    <Link to={'/personal-injury'}>Personal Injury</Link>

                    <Link to={'/business-law'}>Business Law & Commercial Litigation</Link>

                    <div style={{ marginTop: '24px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <a href="tel:+8556435291" className="btn-outline-ivory" style={{ justifyContent: 'center' }}>Call (855) 643-5291</a>
                        <Link to={'/contact-us'} className="btn-gold" style={{ justifyContent: "center" }}>Free Consultation</Link>
                    </div>
                </div> : null
            }


        </>
    );
};

export default Header;
